"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)({
  size_small: {
    width: 18,
    height: 18
  },
  size_medium: {
    width: 24,
    height: 24
  },
  size_large: {
    width: 32,
    height: 32
  }
});

var CountriesFlags = function CountriesFlags(_ref) {
  var countries = _ref.countries,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      groupProps = (0, _objectWithoutProperties2.default)(_ref, ["countries", "size"]);
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_material.AvatarGroup, groupProps, countries.map(function (country) {
    return /*#__PURE__*/_react.default.createElement(_material.Avatar, {
      className: classes["size_".concat(size)],
      key: country.name,
      src: country.image,
      alt: "".concat(country.name, " flag")
    });
  }));
};

var _default = /*#__PURE__*/(0, _react.memo)(CountriesFlags);

exports.default = _default;